// Module
var code = "<div data-bind=\"component: view, style: {width: maxWidth, height: maxHeight}\"></div>";
// Exports
module.exports = code;